import React, { Component } from "react";
import { connect } from "react-redux";
import * as Actions from "../../store/actions/index";
import device from "current-device";
import Grid from "material-ui/Grid";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";
import styled from "styled-components";
import _ from "lodash";
import BeachCard from "../BeachCard";

const ResultsCards = styled.div`
  @media (orientation: portrait) {
    height: 100%;

    @media (min-width: 960px) {
    }
    @media (min-width: 1280px) {
    }
  }
  @media (orientation: landscape) {
    padding: 20px;
    height: calc(100% - 40px);
  }
`;
const Single = styled.div`
  padding: 5px;

  .resultsCard {
    max-width: 280px;
    margin: 15px auto;
  }
`;
const Slide = styled.div``;
const NoResults = styled.div`
  color: rgba(0, 0, 0, 0.54);
  padding: 40px;
`;
const Ad = styled.div`
  height: calc(100% - 40px);
  border-radius: 10px;
  padding: 20px;
  background-size: cover;
`;
const AdLogo = styled.div`
  width: 40%;
  margin-bottom: 10px;
`;
const AdButton = styled.div`
  background: #fff;
  color: #0066ff;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 16px;
  display: inline-block;
  cursor: pointer;
`;
const AdText = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  margin-bottom: 10px;
`;

export class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goToIndex: null,
      newResults: []
    };
  }
  componentDidMount() {
    // console.log('DID MOUNT');\
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.resultsShown) {
      return true;
    } else {
      return false;
    }
  }
  componentWillReceiveProps() {}
  componentDidUpdate() {
    // console.log('selectedItem: ', this.props.selectedItem);
    // console.log('slideSelected: ', this.props.slideSelected);
  }
  handleAdClick = () => {
    const { ad } = this.props;
    this.props.onClickAd();
    window.open(
      ad.url.indexOf("http") === -1 ? "http://" + ad.url : ad.url,
      "_blank"
    );
  };
  showDetail = (item) => {
    this.props.onSetDetail(item);
  };
  renderAd = () => {
    const { ad } = this.props;
    if (ad && ad.hasOwnProperty("logo")) {
      return (
        <Ad
          onClick={this.handleAdClick}
          style={
            ad.image
              ? {
                  backgroundImage:
                    "url(https://s3-us-west-2.amazonaws.com/htb-brc-public/" +
                    ad.image +
                    ")"
                }
              : { border: "1px solid #999" }
          }>
          {ad.logo ? (
            <AdLogo>
              <img
                src={
                  "https://s3-us-west-2.amazonaws.com/htb-brc-public/" + ad.logo
                }
              />
            </AdLogo>
          ) : null}
          {ad.headline ? <AdText>{ad.headline}</AdText> : null}
          {ad.link_text ? <AdButton>{ad.link_text}</AdButton> : null}
        </Ad>
      );
    }
  };
  renderResults = () => {
    const { results, tab, slideSelected, ad, wW, wH } = this.props;
    var cards = [],
      newResults = [...results];
    // console.log(ad);
    // if (ad && ad.hasOwnProperty('showId')) newResults.splice(5, 0, {});

    if (newResults.length > 1) {
      if (ad && !_.isEmpty(ad)) {
        newResults.splice(5, 0, {});
        var tenth = 9;
        for (var i = 0; i < newResults.length; i++) {
          if (i == tenth) {
            newResults.splice(i, 0, {});
            tenth += 10;
          }
        }
        if (Math.abs(newResults.length % 2) == 1 && newResults.length < 5)
          newResults.push({});
      }
      // console.log(newResults);
      cards = newResults.map((result, index) => {
        // console.log(result);
        if (_.isEmpty(result)) {
          return (
            <Grid key={"ad" + index} item xs={12} md={6}>
              {this.renderAd()}
            </Grid>
          );
        }
        if (wH > wW) {
          return (
            <Slide
              key={result.id}
              id={result.id}
              data-lat={result.lat}
              data-lng={result.lng}>
              <BeachCard
                onHoverIn={() => this.props.onSetHover(result.id)}
                onHoverOut={() => this.props.onSetHover(null)}
                onClick={() => this.showDetail(result)}
                beach={result}
                tab={tab}
              />
            </Slide>
          );
        } else {
          return (
            <Grid key={result.id} item xs={12} md={6}>
              <BeachCard
                onHoverIn={() => this.props.onSetHover(result.id)}
                onHoverOut={() => this.props.onSetHover(null)}
                onClick={() => this.showDetail(result)}
                beach={result}
                tab={tab}
              />
            </Grid>
          );
        }
      });
    } else if (newResults.length === 1) {
      return (
        <Single>
          <BeachCard
            onHoverIn={() => this.props.onSetHover(newResults[0].id)}
            onHoverOut={() => this.props.onSetHover(null)}
            onClick={() => this.showDetail(newResults[0])}
            beach={newResults[0]}
            tab={tab}
          />
        </Single>
      );
    }

    if (cards.length > 0) {
      if (wH > wW) {
        var _this = this;
        var _window = window;
        var _doc = document;
        var jQ = $;
        const carousel = {
          dots: false,
          arrows: false,
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 0,
          centerMode: true,
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ],
          afterChange: function (currentSlide) {
            const {
              onRemoveItem,
              onSlideCarousel,
              onSetHover,
              selectedItem,
              onReCenterMap
            } = _this.props;
            var currentLat, currentLng;

            if (currentSlide < _this.slider.props.children.length) {
              var currentId = _this.slider.props.children[currentSlide].key;

              newResults.forEach((result, i) => {
                if (result.id === parseInt(currentId)) {
                  currentLat = result.lat;
                  currentLng = result.lng;
                }
              });
              if (selectedItem) {
                if (currentId !== selectedItem.id) onRemoveItem();
              }
              onSetHover(parseInt(currentId));
              onSlideCarousel(currentId);
              if (device.mobile() && wH > wW) {
                onReCenterMap(currentLat, currentLng);
              }
            }
            _window.setTimeout(function () {
              _window.scrollTo(0, _doc.body.scrollHeight);
            }, 50);
          }
        };

        if (slideSelected && this.slider) {
          newResults.forEach((result, i) => {
            if (result.id === slideSelected) {
              this.slider.slickGoTo(i);
            }
          });
        }
        return (
          <Slider
            id="slider"
            ref={(slider) => (this.slider = slider)}
            {...carousel}>
            {cards}
          </Slider>
        );
      }

      return (
        <Grid container spacing={16}>
          {cards}
        </Grid>
      );
    } else {
      switch (tab) {
        case 0:
          return (
            <NoResults>
              No beaches in the map area. Try zooming out, or searching for a
              beach.
            </NoResults>
          );
        case 1:
          return (
            <NoResults>
              No beaches in the map area have NowCast predictions. Try zooming
              out, or searching for another beach.
            </NoResults>
          );
        case 2:
          return (
            <NoResults>
              No beaches in the map area have Beach Report Card Grades. Try
              zooming out, or searching for another beach.
            </NoResults>
          );
        case 3:
          return (
            <NoResults>
              No beaches in the map area are under Alert. Try zooming out, or
              searching for another beach.
            </NoResults>
          );
      }
    }
  };
  render() {
    return <ResultsCards>{this.renderResults()}</ResultsCards>;
  }
}

const mapStateToProps = (state) => {
  return {
    selectedItem: state.brc.selectedItem,
    clusters: state.brc.clusters,
    mapOptions: state.brc.mapOptions,
    results: state.brc.results,
    wW: state.brc.wW,
    wH: state.brc.wH,
    resultsShown: state.brc.resultsShown,
    slideSelected: state.brc.slideSelected,
    map: state.brc.map,
    maps: state.brc.maps,
    selectedItem: state.brc.selectedItem,
    ad: state.brc.ad
  };
};

export default connect(mapStateToProps, { ...Actions })(Results);



// WEBPACK FOOTER //
// ./src/components/Results/index.js